export enum NotificationLevel {
    success = 'success',
    info = 'info',
    warning = 'warning',
    danger = 'danger',
}

export class NotificationOption {
    public level: NotificationLevel;
    public autoClose: boolean;
    public width: number = 300;
    public time: number = 5000;
    public message: string = '';
}

export class Notification {
    public id: string;
    public message: string;
    public level: NotificationLevel;
}

export interface INotificationService {
    createTimedSuccessTranslateMessage(message: string, seconds?: number, width?: number): void;
    createTimedInfoTranslateMessage(message: string, seconds?: number, width?: number): void;
    createTimedWarningTranslateMessage(message: string, seconds?: number, width?: number): void;
    createTimedDangerTranslateMessage(message: string, seconds?: number, width?: number): void;
    createSuccessTranslateMessage(message: string, width?: number): void;
    createInfoTranslateMessage(message: string, width?: number): void;
    createWarningTranslateMessage(message: string, width?: number): void;
    createDangerTranslateMessage(message: string, width?: number): void;
    notify(options: NotificationOption): void;
    createOption(message: string, level: NotificationLevel, width?: number): NotificationOption;
    closeAllMessages(): void;
}
